export class PhotographerBase {
  public personId?: number;
  public firstName?: string;
  public lastName?: string;
  public fullName?: string;

  public showMenu?: boolean;
}
